import React from 'react';
import { ApolloProvider, gql, useQuery } from '@apollo/client';
import client from '../lib/apolloClient';
import DealRoomMarketplacePage from '../components/Succeedo/DealRoom/DealRoomMarketplacePage';

// Seller hub. Buyer marketplace browse is deferred to a Polymet-driven
// follow-up ticket (D13 — Buyer Marketplace). The search_deal_listings
// query stays available; we just don't fetch it here yet.
const SELLER_HUB_QUERY = gql`
  query DealRoomSellerHub {
    currentUser {
      id
      name
      succeedo_persona
      company { id marketplace_tagline }
    }
    my_deal_listings {
      id
      headline
      industry
      revenue_range_bucket
      deal_state
      confidential
    }
  }
`;

function deriveInitials(name) {
  if (!name) return '??';
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] || '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
}

function DealRoomLoader() {
  const { data, loading } = useQuery(SELLER_HUB_QUERY, { fetchPolicy: 'cache-and-network' });

  React.useEffect(() => {
    if (typeof window !== 'undefined' && window.ahoy?.track) {
      try { window.ahoy.track('succeedo_deal_room_viewed'); } catch (_e) {}
    }
  }, []);

  const user = data?.currentUser;
  const myListings = data?.my_deal_listings || [];

  return (
    <DealRoomMarketplacePage
      myListings={myListings}
      myListingsLoading={loading}
      marketplaceTagline={user?.company?.marketplace_tagline || ''}
      persona={(user?.succeedo_persona || 'seller').toUpperCase()}
      userName={user?.name || ''}
      userInitials={deriveInitials(user?.name)}
      onCreateListing={() => { window.location.href = '/succeedo/deal-room/new'; }}
    />
  );
}

export default function SucceedoDealRoomContainer() {
  return (
    <ApolloProvider client={client}>
      <DealRoomLoader />
    </ApolloProvider>
  );
}
